export default __webpack_public_path__ + "static/media/github-social.033edaef.png";